<template>
  <div :id="uid" class="link-block">
    <a :href="url"
       target="_blank"
       :download="description">
      <div class="row">
        <div class="fb-icon-col col-xs-2 col-sm-3">
          <div class="rounded-background center-block">
            <div class="icon-container">
              <svg-icon :icon="icon" color="#fff"/>
            </div>
          </div>
        </div>
        <div class="col-xs-10 col-sm-9">
          <div class="title-container">
            <h5><b v-html="title"></b></h5>
            <p><small v-html="text"></small></p>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import svgIcon from '@/sui/components/svgIcon'

export default {
  name: 'link-block',
  props: {
    link: String,
    description: String,
    title: String,
    icon: String,
    text: String,
    color: String
  },

  computed: {
    uid () {
      return 'link-block-' + this._uid
    },

    url () {
      if (this.link == null) {
        return null
      }

      return this.link.startsWith('http')
        ? this.link : require('@/assets/' + this.link)
    }
  },

  components: {
    'svg-icon': svgIcon
  }
}
</script>
<style scoped lang="less">
@import '~variables';
@import '~modules';

.link-block {
  list-style-type: none;
  line-height: 1.2rem;
  margin-bottom: 1rem;
  a {
    color: @base-text;
  }
}

.link-block-alt a{
  color: white;
}

.rounded-background {
  position: relative;
  width: 90%;
  padding-top: 90%;
  height: 0;
  background-color: black;
  border-radius: 50%;
  display: block;
}

.fb-icon-col {
  padding-left: 1.5%;
  padding-right: 1.5%;
  max-width: 120px;
}

.fb-default .rounded-background {
  background-color: @gray-light;
}

.icon-container {
  position: absolute;
  top: 15%;
  left: 15%;
  bottom: 15%;
  right: 15%;
}
</style>
